import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import NotFound from './views/NotFound.vue'
import Room from './components/Room.vue'
import Rule from './views/Rule.vue'

Vue.use(Router)

const router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/room:room',
      props: true,
      name: 'HomeInvited',
      component: Home
    },
    {
      path: '/room',
      name: 'RoomWaiting',
      component: Room,
    },
    {
      path: '/room/:roomId',
      name: 'Room',
      component: Room,
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    },
    {
      path: '/rule',
      name: 'Rule',
      component: Rule
    }
  ]
});


export default router;
